import React from 'react'
const NoRecordFound = () => {
    return (
        <div className='d-flex justify-content-center align-items-center gap-2 p-2  rounded mt-4'>
            <i className="fas fa-exclamation-triangle text-dark ms-2 fs-4"></i>
            <h4 className="mb-0 text-gray-600"> No Records Found</h4>
        </div>
    )
}

export default NoRecordFound